var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-pane-inner" }, [
    _c("div", { staticClass: "go-add-input" }, [
      _c(
        "div",
        { staticClass: "go-form-group go-form-group-search" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchValue,
                expression: "searchValue",
              },
            ],
            staticClass: "go-form-control",
            attrs: {
              placeholder: _vm.$t(
                "popupAddReference.urlTab.placeHolderInputUrl"
              ),
              type: "url",
              disabled: _vm.isShowSpinner === true,
            },
            domProps: { value: _vm.searchValue },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.preview.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchValue = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          !_vm.isShowSpinner
            ? _c(
                "button",
                {
                  staticClass: "btn go-btn-icon",
                  attrs: { type: "submit" },
                  on: { click: _vm.preview },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-link-add" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowSpinner === true
            ? _c("b-spinner", {
                staticStyle: { position: "absolute", top: "30%", right: "2%" },
                attrs: { small: "", label: "Small Spinner" },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "go-list-wrap" },
      [
        _c(
          "vue-custom-scrollbar",
          {
            staticClass:
              "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
            attrs: { settings: _vm.scrollSettings },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "hidden",
                  width: "auto",
                  height: "auto",
                },
              },
              [
                _c(
                  "ul",
                  { staticClass: "go-card-sub-list go-card-resource" },
                  _vm._l(_vm.previewModels, function (refItem) {
                    return _c("ref-item", {
                      key: refItem.id,
                      attrs: {
                        "form-model": refItem,
                        "is-has-link": true,
                        "remove-able": true,
                      },
                      on: {
                        openLink: function ($event) {
                          return _vm.openNewTab(refItem.link || refItem.url)
                        },
                        remove: function ($event) {
                          return _vm.removeCardInList(refItem)
                        },
                        toggleBookmark: function ($event) {
                          return _vm.selectAddingReferenceDocument(refItem)
                        },
                      },
                    })
                  }),
                  1
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }